var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-progress"},[_c('div',{staticClass:"s-progress_bar"},[_c('div',{staticClass:"s-progress_bar-outer",style:({ height: _vm.strokWidth + 'px'})},[_c('div',{staticClass:"s-progress_bar-inner",style:(_vm.barStyle)})])])])}
var staticRenderFns = []

export { render, staticRenderFns }